import { StyledShoppingListHeader } from 'components/ShoppingList/Header/Header.styled';
export const ShoppingListHeader = () => {
  return <StyledShoppingListHeader>Shopping list</StyledShoppingListHeader>;
};
